export const statusList = [
  { label: '未提交', value: 0 },
  { label: '审核中', value: 1 },
  { label: '签收中', value: 2 },
  { label: '整改中', value: 3 },
  { label: '延期审批中', value: 4 },
  { label: '验收中', value: 5 },
  { label: '已闭环', value: 6 },
  { label: '被驳回', value: 7 },
]
//1：逾期未整改 2：即将到期未整改 3：超期完成整改
export const colorList = [
  { label: '逾期未整改', value: 1 },
  { label: '即将到期未整改', value: 2 },
  { label: '超期完成整改', value: 3 },
]
export const violatedBasicInfoProps = {
  //违章上报新增/编辑
  reportVioAdd: {
    isAble: [],
    isDisAbled: false,
    isAllAble: true,
    isMustReq: [
      'description',
      'areaId',
      'violationTime',
      'typeId',
      'levelId',
      'orgId',
      'pictures',
      'reportPersonName',
      'reportPersonOrgId',
      'reportTime',
    ],
  },
  //违章上报详情
  reportVioInfo: {
    isAble: [],
    isDisAbled: true,
    isAllAble: false,
    isMustReq: [],
  },
  //违章考核新增/编辑
  examineAdd: {
    isAble: [],
    isDisAbled: false,
    isAllAble: true,
    isMustReq: [
      'description',
      'violationTime',
      'typeId',
      'levelId',
      'orgId',
      'pictures',
      'reportPersonOrgId',
    ],
  },
  //违章考核详情
  examineInfo: {
    isAble: [],
    isDisAbled: true,
    isAllAble: false,
    isMustReq: [],
  },
  //违章签收
  examineSign: {
    isAble: ['violators'],
    isDisAbled: false,
    isAllAble: false,
    isMustReq: [],
  },
  //违章审核
  audit: {
    isAble: ['typeId', 'levelId', 'orgId', 'violators', 'violationTime'],
    isDisAbled: false,
    isAllAble: false,
    isMustReq: ['typeId', 'levelId'],
  },
}
export const sourceList = {
  //违章验收
  violationAccept: {
    limitType: 'allDisabled',
    props: [],
    reqMust: [],
  },
  //违章延期
  delay: {
    limitType: 'disabled',
    props: ['description', 'areaid', 'reportTime', 'reportPersonId', 'pictures'],
    reqMust: [],
  },
  //违章查看
  look: {
    limitType: 'allDisabled',
    props: [],
    reqMust: [],
  },
  //违章考核新增/编辑
  vioExamine: {
    limitType: 'allAgree',
    props: [],
    base: 'examineAdd',
    reqMust: [
      'signeeId',
      'signeeOrgId',
      'rectDeadline',
      'acceptedById',
      'trainHour',
      'penaltyScore',
      'penaltyAmount',
      'rewardScore',
      'rewardAmount',
      'rewardPersonnel',
      'punishPersonnel',
      'responsiblePersonnel',
    ],
  },
  //查看
  vioExamineInfo: {
    limitType: 'allDisabled',
    props: [],
    base: 'examineInfo',
    reqMust: [],
  },
  //考核签收
  vioExamineSign: {
    limitType: 'agree',
    props: ['rectRespPersonId', 'rectRespOrgId', 'rectRequirements'],
    reqMust: ['rectRespPersonId'],
    base: 'examineSign',
  },
  //违章整改
  vioExamineRectify: {
    limitType: 'agree',
    props: ['rectSituation','pictures','finishedDate'],
    reqMust: ['rectSituation','pictures','finishedDate'],
    base: 'examineInfo',
  },
  //违章验收
  violationAccept: {
    limitType: 'allDisabled',
    props: [],
    reqMust: [],
    base: 'examineInfo',
  },
  //违章审核
  violationAudit: {
    limitType: 'allAgree',
    props: [],
    base: 'audit',
    reqMust: [
      'signeeId',
      'signeeOrgId',
      'rectDeadline',
      'acceptedById',
      'penaltyScore',
      'rewardScore',
      'rewardPersonnel',
      'punishPersonnel',
      'responsiblePersonnel',
    ],
  },
}
//章节内容
export const disappearList = {
  rectification: [
    'rectRespPersonId',
    'rectRespPersonName',
    'rectRespOrgId',
    'rectRespOrgName',
    'rectDeadline',
    'acceptedByName',
    'acceptedById',
    'acceptedTime',
    'rectRequirements',
  ],
  penalty: ['penaltyBasis', 'penaltyScore', 'penaltyAmount', 'trainHour', 'punishPersonnel'],
  rewards: ['rewardBasis', 'rewardScore', 'rewardAmount', 'rewardPersonnel'],
}
